import React, { useEffect, useRef } from 'react';
import styles from 'src/pages/Design/pages/BeginnerGsapAnimation/BeginnerGsapAnimation.module.scss';
import { gsap } from 'gsap';

const BeginnerGsapAnimation: React.FC = () => {
  const boxRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    // NOTE: for some reason when you do '+=360', the 360 rotation isn't exactly 360 everytime. It is around 360 like 355, 367, etc.???
    gsap.to(boxRef.current, { rotation: `360_ccw`, duration: 2 });
  }, []);

  return (
    <div className={styles.container}>
      <div
        className={styles.box}
        ref={boxRef}
      >
        Beginner Gsap Animation
      </div>
    </div>
  );
};

export default BeginnerGsapAnimation;
